<template>
  <v-container fluid pa-0>
    <v-row class="cv-welcome-top">
      <v-row class="cv-welcome-inner-top" align-content="center">
        <v-col cols="12" sm="6" align-self="center">
          <h1 class="display-80 font-weight-medium mb-md-5 mb-1 black--text">
            {{ header }}
          </h1>
          <h2 class="display-36 font-weight-medium black--text ">
            {{ subHeader }}
          </h2>

          <v-btn
            class="start-btn mt-6"
            rounded
            :color="btnColor"
            height="auto"
            :to="'/קורות-חיים/1/'"
          >
            {{ topBtn }}
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="text-left"
          align-self="center"
          align-content="center"
        >
          <img :src="previewImage" class="top-img" alt="קורות חיים" />
        </v-col>
      </v-row>
    </v-row>
    <v-row class="my-6 pt-2">
      <v-col>
        <h3
          class="text-center display-30 primary--text font-weight-medium"
          v-html="introText"
        />
      </v-col>
    </v-row>
    <div class="section_inner" pa-0>
      <v-row class="text-center section_inner m-auto">
        <v-col
          cols="12"
          md="6"
          sm="3"
          color="indigo"
          v-for="(step, i) in steps"
          :key="i"
        >
          <v-row>
            <v-col class="text-center" cols="3">
              <v-img size="50" :src="step.previewImage" class="inner-img" />
            </v-col>
            <v-col cols="9" class="text-right my-1 display-18">
              <p class="mb-0">
                <span class="font-weight-medium">
                  {{ step.textBold }}
                </span>
                {{ step.text }}
              </p>
              <p>
                {{ step.textExpand }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  head() {
    return {
      title: 'כתיבת קורות חיים מקצועיים בחינם',
      meta: [
        {
          name: 'description',
          content:
            'כתיבת קורות חיים מקצועיים הם הצעד הראשון שיש לבצע בזמן חיפוש עבודה. דרושים IL מעמיד לרשותכם כלי קל ויעיל לכתיבת קורות חיים בחינם.',
          hid: 'DESCRIPTION',
        },
      ],
      link: [
        {
          /** canonical on jobs page genrated by nuxt  */
          rel: 'canonical',
          href:
            'https://www.drushim.co.il' +
            encodeURI(this.$route.fullPath).toUpperCase(),
        },
      ] /*this.seodata.canonicalUrl */,
    };
  },
  layout: 'innerPage',
  name: 'cvPage',
  data() {
    return {
      header: 'קורות חיים בקליק',
      subHeader: 'כתיבת קורות חיים  מקצועיים בחינם!',
      previewImage: require('../../assets/img/cv_wizard/header_img.png'),
      steps: {
        1: {
          previewImage: require('../../assets/img/cv_wizard/s1.jpg'),
          textBold: 'בניית קובץ קורות חיים במהירות ובחינם',
          text: 'תוך הקפדה על מבנה נכון ונוח לקריאה.',
          textExpand:
            'פורמט קורות חיים צריך לכלול פרטים מסוימים בהתאם לקודים ברורים לפיהם נהוג ליצור את המסמך, לכן חשוב להתאים את קורות החיים למשרה בה אתם מעוניינים.',
        },
        2: {
          previewImage: require('../../assets/img/cv_wizard/s2.jpg'),
          textBold: 'תהליך הזנת פרטים רלוונטיים קצר ויעיל.',
          text: 'מותאם לדרישות המעסיקים.',
          textExpand:
            'מסמך קורות חיים חייב להכיל בראש העמוד פרטים אישיים ופרטי התקשרות, ובהם שם, טלפון, עיר מגורים וכתובת דואר אלקטרוני.',
        },
        3: {
          previewImage: require('../../assets/img/cv_wizard/s3.jpg'),
          textBold: 'עיצוב מבנה קורות חיים נוח, ברור ומרשים!',
          text: '',
          textExpand:
            'דף קורות החיים צריכים להיות נקיים, מזמינים וקלים לקריאה ובאורך של עמוד. חשוב להקפיד על הגהה, תמציתיות ובהירות.',
        },
        4: {
          previewImage: require('../../assets/img/cv_wizard/s4.jpg'),
          textBold: 'קבלת קובץ קו"ח ערוך ומוכן לשליחה מיידית!',
          text: '',
          textExpand:
            'טיפ: בסוף עמוד קורות חיים רצוי להוסיף משפט כגון: "הפניה להמלצות תינתן בהתאם לדרישה" או "המלצות יימסרו על פי דרישה".',
        },
      },

      topBtn: 'מתחילים מכאן >',
      introText:
        'מערכת MyCV של דרושים IL תיצור לך קובץ קורות חיים <br> מותאם ומדויק שיבלוט בשוק העבודה',
      btnColor: 'green',
    };
  },
  computed: {},
  methods: {},
  mounted() {
    this.$store.dispatch('loadCVWContent');
  },
};
</script>

<style lang="scss" scoped>
.cv-welcome-top {
  background-color: #b9e5f9;
  padding: 10px 12px;
  text-align: center;
}
.cv-welcome-inner-top {
  max-width: 1260px;
  margin: 0 auto;
}
.top-img {
  width: 100%;
}
.v-btn:not(.v-btn--round).v-size--default.start-btn {
  padding: 10px 60px;
  border-radius: 34px;
  border: 2px solid #0e8a53 !important;
  background-color: $send-cv-button;
  color: #fff;
  font-size: 20px;
}

.inner-img {
  max-width: 150px;
  margin: 0 auto;
}

@media screen and (min-width: 600px) {
  .v-btn:not(.v-btn--round).v-size--default.start-btn {
    background-color: $primary;
    font-size: 30px;
  }
  .cv-welcome-top {
    text-align: right;
  }
  .top-img {
    max-width: 360px;
  }
}
</style>
